import { createStyles, makeStyles } from '@material-ui/core';
import { FONT_FAMILY } from '../../../constants';

export const useStyles = makeStyles(() =>
  createStyles({
    filterTextMobile: { marginTop: '2%', marginLeft: '1%' },
    filterTextMobileSecondTable: {
      marginTop: '7.2%',
      marginLeft: '1%',
    },

    dropDown2: {
      height: '20px',
      width: '20px',
      marginTop: '7px',
    },
    headingStyle: {
      fontFamily: FONT_FAMILY,
      fontWeight: 'bold',
      marginTop: '2%',
    },
    headingStyleMobile: {
      fontFamily: FONT_FAMILY,
      fontWeight: 'bold',
      marginTop: '2%',
      fontSize: '13px',
    },
    filterText: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '1%',
      marginRight: '2%',
    },
  })
);



// WEBPACK FOOTER //
// ./src/Pages/HomePage/InterestChangeFilterBar/index.styles.js